import { Flex, Badge, Em, Text } from "@radix-ui/themes";
import { OptionalFieldGroup } from "./FieldGroup";
import { EmailListInput } from "./EmailListInput";

interface SendWalkthroughAtBeginningProps {
  enabled?: boolean;
  emails?: string[];
  onChange: (enabled: boolean) => void;
  onEmailsChange: (emails: string[]) => void;
}

export function SendWalkthroughAtBeginning({
  enabled = false,
  emails = [],
  onChange,
  onEmailsChange,
}: SendWalkthroughAtBeginningProps) {
  return (
    <OptionalFieldGroup
      label={
        <Flex align="center" gap="2">
          <Text size="2">Show Walkthrough</Text>
          <Badge color="plum" variant="soft" highContrast>
            <Em>Beta</Em>
          </Badge>
        </Flex>
      }
      description={"Show a guided walkthrough based on chat context."}
      enabled={enabled ?? false}
      toggleEnabled={onChange}
    >
      {enabled && (
        <Flex mt="2" direction="column" gap="2">
          <Text size="2" color="gray">
            Enable walkthrough suggestions for specific email addresses
          </Text>
          <EmailListInput emails={emails} onChange={onEmailsChange} />{" "}
        </Flex>
      )}
    </OptionalFieldGroup>
  );
}
